import { PropsWithChildren, FC, useContext } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { ErrorBoundaryContext } from '../../contexts/ErrorBoundary.context';

type ErrorBoundaryProps = PropsWithChildren<{}>;

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children }) => {
  const { fallback } = useContext(ErrorBoundaryContext);

  return (
    <SentryErrorBoundary fallback={() => <>{fallback}</>}>
      {children}
    </SentryErrorBoundary>
  );
};
